import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

firebase.initializeApp({
    apiKey: "AIzaSyDJQaKiPedR2BNrooPw6a6a5A5gibInFhM",
    authDomain: "batcheet-10.firebaseapp.com",
    projectId: "batcheet-10",
    storageBucket: "batcheet-10.appspot.com",
    messagingSenderId: "833364426046",
    appId: "1:833364426046:web:2b4fd0106e146106aa806f",
    measurementId: "G-B39KG1RZN9"
});

const db = firebase.firestore();
export default db;
